import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

// modules
import { AlertModule } from 'app/components/alert/alert.module';
import { CommentModule } from 'ng2-app/modules/comment/comment.module';
import { SharedModule } from 'ng2-app/shared-module';
import { TimeAgoModule } from 'ng2-app/pipes/time-ago/time-ago-pipe.module';
import { DocumentPillModule } from 'ng2-app/components/document-pill/document-pill.module';
import { LsDropdownModule } from 'ng2-app/components/ls-dropdown/ls-dropdown.module';

// components
import { BorrowerActivityComponent } from './borrower-activity/borrower-activity.component';
import { BorrowerActivityStreamComponent } from './borrower-activity-stream.component';
import { ChecklistComponent } from 'ng2-app/components/checklist/checklist.component';

// Pipes
import { KeysPipeModule } from 'ng2-app/pipes/keys/keys-pipe.module';
import { TelPipeModule } from 'ng2-app/pipes/tel/tel-pipe.module';
import { TimerPipeModule } from 'ng2-app/pipes/timer/timer-pipe.module';
import { StatusDisplayModule } from 'ng2-app/pipes/status-display/status-display-pipe.module';
import { TruncateModule } from 'ng2-app/pipes/truncate/truncate-pipe.module';
import { PhoneModule } from 'ng2-app/pipes/phone/phone-pipe.module';

// Activity templates
import { ActivityRowAcceptedBankStatementTermsComponent } from './borrower-activity-row-types/activity-row-accepted-bank-statement-terms/activity-row-accepted-bank-statement-terms.component';
import { ActivityRowAktifyReengagementComponent } from './borrower-activity-row-types/activity-row-aktify-reengagement/activity-row-aktify-reengagement.component';
import { ActivityRowApplicationComponent } from './borrower-activity-row-types/activity-row-application/activity-row-application.component';
import { ActivityRowAssignmentComponent } from './borrower-activity-row-types/activity-row-assignment/activity-row-assignment.component';
import { ActivityRowBankAggregatorComponent } from './borrower-activity-row-types/activity-row-bank-aggregator/activity-row-bank-aggregator.component';
import { ActivityRowBouncedMessageComponent } from './borrower-activity-row-types/activity-row-bounced-message/activity-row-bounced-message.component';
import { ActivityRowCallComponent } from './borrower-activity-row-types/activity-row-call/activity-row-call.component';
import { ActivityRowChatComponent } from './borrower-activity-row-types/activity-row-chat/activity-row-chat.component';
import { ActivityRowCxInteractionComponent } from './borrower-activity-row-types/activity-row-cx-interaction/activity-row-cx-interaction.component';
import { ActivityRowCreatedComponent } from './borrower-activity-row-types/activity-row-created/activity-row-created.component';
import { ActivityRowDealComponent } from './borrower-activity-row-types/activity-row-deal/activity-row-deal.component';
import { ActivityRowDefaultComponent } from './borrower-activity-row-types/activity-row-default/activity-row-default.component';
import { ActivityRowDeletedComponent } from './borrower-activity-row-types/activity-row-deleted/activity-row-deleted.component';
import { ActivityRowMessageComponent } from './borrower-activity-row-types/activity-row-message/activity-row-message.component';
import { ActivityRowNoteComponent } from './borrower-activity-row-types/activity-row-note/activity-row-note.component';
import { ActivityRowNextStepComponent } from './borrower-activity-row-types/activity-row-next-step/activity-row-next-step.component';
import { ActivityRowReminderComponent } from './borrower-activity-row-types/activity-row-reminder/activity-row-reminder.component';
import { ActivityRowReminderFiredComponent } from './borrower-activity-row-types/activity-row-reminder-fired/activity-row-reminder-fired.component';
import { ActivityRowSignupComponent } from './borrower-activity-row-types/activity-row-signup/activity-row-signup.component';
import { ActivityRowPPPOptInComponent } from './borrower-activity-row-types/activity-row-ppp-opt-in/activity-row-ppp-opt-in.component';
import { ActivityRowPPPOptOutComponent } from './borrower-activity-row-types/activity-row-ppp-opt-out/activity-row-ppp-opt-out.component';
import { ActivityRowSmsComponent } from './borrower-activity-row-types/activity-row-sms/activity-row-sms.component';
import { BorrowerActivityCommentComponent } from './borrower-activity-comment/borrower-activity-comment.component';
import { BorrowerActivityCommentFormComponent } from './borrower-activity-comment-form/borrower-activity-comment-form.component';
import { BorrowerActivityCommentsComponent } from './borrower-activity-comments/borrower-activity-comments.component';
import { UserAvatarModule } from 'app/user-avatar/user-avatar.module';
import { ActivityRowDocCategoryVerifiedComponent } from './borrower-activity-row-types/activity-row-doc-category-verified/activity-row-doc-category-verified.component';
import { ActivityRowDocCategoryUpdatedComponent } from './borrower-activity-row-types/activity-row-doc-category-updated/activity-row-doc-category-updated.component';
import { ActivityRowDocRejectedComponent } from './borrower-activity-row-types/activity-row-doc-rejected/activity-row-doc-rejected.component';
import { ActivityRowDocCategoryUnknownComponent } from './borrower-activity-row-types/activity-row-doc-category-unknown/activity-row-doc-category-unknown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { RouterModule } from '@angular/router';
import { ActivityRowBankConnectionComponent } from './borrower-activity-row-types/activity-row-bank-connection/activity-row-bank-connection.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    AlertModule,
    CommentModule,
    CommonModule,
    DocumentPillModule,
    FormsModule,
    KeysPipeModule,
    LsDropdownModule,
    MatChipsModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    PhoneModule,
    RouterModule,
    SharedModule,
    StatusDisplayModule,
    TelPipeModule,
    TimeAgoModule,
    TimerPipeModule,
    TooltipModule,
    TruncateModule,
    UserAvatarModule,
  ],
  exports: [
    BorrowerActivityStreamComponent
  ],
  declarations: [
    ActivityRowAcceptedBankStatementTermsComponent,
    ActivityRowAktifyReengagementComponent,
    ActivityRowApplicationComponent,
    ActivityRowAssignmentComponent,
    ActivityRowBankAggregatorComponent,
    ActivityRowBankConnectionComponent,
    ActivityRowBouncedMessageComponent,
    ActivityRowCallComponent,
    ActivityRowChatComponent,
    ActivityRowCreatedComponent,
    ActivityRowCxInteractionComponent,
    ActivityRowDealComponent,
    ActivityRowDefaultComponent,
    ActivityRowDeletedComponent,
    ActivityRowDocCategoryUnknownComponent,
    ActivityRowDocCategoryUpdatedComponent,
    ActivityRowDocCategoryVerifiedComponent,
    ActivityRowDocRejectedComponent,
    ActivityRowMessageComponent,
    ActivityRowNextStepComponent,
    ActivityRowNoteComponent,
    ActivityRowPPPOptInComponent,
    ActivityRowPPPOptOutComponent,
    ActivityRowReminderComponent,
    ActivityRowReminderFiredComponent,
    ActivityRowSignupComponent,
    ActivityRowSmsComponent,
    BorrowerActivityCommentComponent,
    BorrowerActivityCommentFormComponent,
    BorrowerActivityCommentsComponent,
    BorrowerActivityComponent,
    BorrowerActivityStreamComponent,
    ChecklistComponent,
  ]
})
export class BorrowerActivityStreamModule { }
